import {useNavigate} from "react-router-dom";
import {TNavigation} from "@/types/navigation/navigationTypes";
import {usePathname} from "@/utils/hooks/usePathname";
import {useAuth0} from "@auth0/auth0-react";
import useMixpanel from "@/utils/hooks/useMixPanel";
import {MixpanelItems} from "@/utils/mixpanelItems";
// import {useSelector} from "react-redux";
// import {appSelector} from "../../../../../redux/app/appSelector";

export const useSideBarBottomMenu = () => {
    const navigate = useNavigate();
    const {isSupportPage, isFAQPage} = usePathname();
    const { isAuthenticated} = useAuth0();
    const {trackEvent} = useMixpanel();

    const openPage = (path: TNavigation) => {
        navigate(`${path}`);
    }

    const mixpanelClickSupport = () => {
        trackEvent(MixpanelItems.ClickSupport)
    }

    return {
        openPage,
        isSupportPage,
        isFAQPage,
        isAuthenticated,
        mixpanelClickSupport
    }
}